<div class="font-bold mb-3" i18n>What encryption scheme do you want to use?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      @for (scheme of encryptionSchemes; track scheme.value) {
        <td>
          <p-radioButton
            (onClick)="primaryEncryptionSchemeSelected()"
            name="suciEncryptionScheme.primaryEncryptionScheme"
            [inputId]="'suciEncryptionScheme.primaryEncryptionScheme#' + scheme.value"
            [value]="scheme.value"
            [(ngModel)]="profileValues.suciEncryptionScheme.primaryEncryptionScheme"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" [for]="'suciEncryptionScheme.primaryEncryptionScheme#' + scheme.value">
            {{ scheme.label }}
          </label>
        </td>
      }
    </tr>
  </table>
</div>
@if (profileValues.suciEncryptionScheme.primaryEncryptionScheme !== null) {
  <div class="font-bold mb-3" i18n>Do you want to add another encryption scheme?</div>
  <div class="ml-6">
    <table style="border-collapse: separate; border-spacing: 0 20px">
      <tr>
        <td>
          <p-radioButton
            (onClick)="handleFormEvents()"
            name="suciEncryptionScheme.addSecondEncryptionScheme"
            inputId="suciEncryptionScheme.addSecondEncryptionScheme#1"
            value="1"
            [(ngModel)]="profileValues.suciEncryptionScheme.addSecondEncryptionScheme"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="suciEncryptionScheme.addSecondEncryptionScheme#1" i18n>Yes</label>
        </td>
        <td>
          <p-radioButton
            (onClick)="handleFormEvents()"
            name="suciEncryptionScheme.addSecondEncryptionScheme"
            inputId="suciEncryptionScheme.addSecondEncryptionScheme#0"
            value="0"
            [(ngModel)]="profileValues.suciEncryptionScheme.addSecondEncryptionScheme"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="suciEncryptionScheme.addSecondEncryptionScheme#0" i18n>No</label>
        </td>
      </tr>
    </table>
  </div>
}
@if (+profileValues.suciEncryptionScheme.addSecondEncryptionScheme === 1) {
  <div class="font-bold mb-3" i18n>Select secondary encryption scheme.</div>
  <div class="ml-6">
    <table style="border-collapse: separate; border-spacing: 0 20px">
      <tr>
        @for (scheme of encryptionSchemes; track scheme.value) {
          <td>
            <p-radioButton
              (onClick)="handleFormEvents()"
              name="suciEncryptionScheme.secondEncryptionScheme"
              [inputId]="'suciEncryptionScheme.secondEncryptionScheme#' + scheme.value"
              [value]="scheme.value"
              [disabled]="isSecondarySchemeDisabled(scheme.value)"
              [(ngModel)]="profileValues.suciEncryptionScheme.secondEncryptionScheme"
            ></p-radioButton>
          </td>
          <td>
            <label class="ml-2 mr-6 label-clickable" [for]="'suciEncryptionScheme.secondEncryptionScheme#' + scheme.value">
              {{ scheme.label }}
            </label>
          </td>
        }
      </tr>
    </table>
  </div>
}
@if (
  +profileValues.suciEncryptionScheme.addSecondEncryptionScheme === 1 && profileValues.suciEncryptionScheme.secondEncryptionScheme !== null
) {
  <div class="font-bold mb-3" i18n>Do you want to add the remaining scheme as well?</div>
  <div class="ml-6">
    <table style="border-collapse: separate; border-spacing: 0 20px">
      <tr>
        <td>
          <p-radioButton
            (onClick)="handleFormEvents()"
            name="suciEncryptionScheme.addRemainingEncryptionScheme"
            inputId="suciEncryptionScheme.addRemainingEncryptionScheme#1"
            value="1"
            [(ngModel)]="profileValues.suciEncryptionScheme.addRemainingEncryptionScheme"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="suciEncryptionScheme.addRemainingEncryptionScheme#1" i18n>Yes</label>
        </td>
        <td>
          <p-radioButton
            (onClick)="handleFormEvents()"
            name="suciEncryptionScheme.addRemainingEncryptionScheme"
            inputId="suciEncryptionScheme.addRemainingEncryptionScheme#0"
            value="0"
            [(ngModel)]="profileValues.suciEncryptionScheme.addRemainingEncryptionScheme"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="suciEncryptionScheme.addRemainingEncryptionScheme#0" i18n>No</label>
        </td>
      </tr>
    </table>
  </div>
}
